<template>
    <div>
        <sample-header></sample-header>
        <div class="text-center header_padding header-margin">
            <!-- <h1>Support</h1> -->
            <br>
            <!--
            <p class="text-center">Questions or Comment?</p>
            <p class="status-smalltext"> Please contact us at
                <a href="mailto:EssilorEvaluationProductSupport@essilorusa.com?subject=General question">EssilorEvaluationProductSupport@essilorusa.com</a>
            </p>
            -->
        </div>
        <div class="row support-section">
            <h3>What is essilorevaluationproduct.com?</h3>
            <p>To support the launch and adoption of Essilor lenses, Essilor will occasionally be distributing Complimentary Evaluation Product to selected Individuals and/or Eyecare Professionals for trial purposes. The essilorevaluationproduct.com site is an online mechanism for Essilor to support its customers by allowing users to submit Evaluation Product Redemption Codes and place an order for their trial eyeglass lenses.</p>
            <h3>How will someone receive their Complimentary Evaluation Product Redemption Codes?</h3>
            <p>For Essilor Evaluation Product Programs, an email will be sent to select Individuals and/or Eyecare Professionals containing a unique Evaluation Product Redemption Code. To redeem this code, the individual will be directed to <a href="https://www.essilorevaluationproduct.com">www.essilorevaluationproduct.com</a> where they will utilize their Redemption Code to place an order for the product or products included in the specific Evaluation Product Program indicated by that Redemption Code.</p>
            <h3>What lenses are available in the Evaluation Product Program?</h3>
            <p>The Evaluation Product Redemption Codes are each connected to a specific Evaluation Product Program, and the lenses available in each program are displayed when the Redemption Code has been entered. No substitutions or alterations will be available.</p>
            <h3>How long will it take to receive the finished lenses?</h3>
            <p>The estimated delivery time is 4-6 weeks from the date the individual’s frames are received at the processing center. This time frame may vary unexpectedly. </p>
            <h3>How can an individual check the status of their Evaluation Product job?</h3>
            <p> Upon redemption, a Confirmation Number will be displayed, and also emailed to address entered on the order form. Job status can be reviewed by visiting 
                <a href="https://www.essilorevaluationproduct.com/status">www.essilorevaluationproduct.com/status</a>  and entering either the Confirmation Number or the unique Evaluation Product Redemption Code used when placing the order. You can also find the lab's phone number for further assistance.
            <h3>Can a Evaluation Product code be redeemed more than once?</h3>
            <p>No. Each code is valid for only one redemption. Each code is valid for one pair of finished spectacle eyeglass lenses.</p>
            <h3>What if a redemption code has expired?</h3>
            <p>Each Redemption Code has a set expiration date, which is communicated when the code is originally delivered. No exceptions can be made for codes that have expired. </p>
            <h3>Can a Evaluation Product redemption code be redeemed at an Eyecare Professional’s primary lab?</h3>
            <p>No, all evaluation products are being processed centrally to control workload and consistency. Each Evaluation Product redemption code is only valid to be used at
                <a href="https://www.essilorevaluationproduct.com">www.essilorevaluationproduct.com</a>. When an order has been submitted, a Confirmation Page will be displayed with shipping instructions.</p>
            <h3>How can we help?</h3>
            <p>We are here to listen to your feedback or assist with any issues you have! Please contact us by email at <a href="mailto:NPLEsupport@essilorusa.com">NPLEsupport@essilorusa.com</a></p>
        </div>
        <div class="row" style="margin-bottom:20px"></div>
        <sample-footer></sample-footer>
    </div>
</template>
<script>
import SampleHeader from "@/components/layout/SampleHeader";
import SampleFooter from "@/components/layout/SampleFooter";
export default {
  components: { SampleHeader, SampleFooter }
};
</script>
<style>
.contactus-container {
  min-height: 350px;
}

.support-section h3 {
  margin-top: 30px;
  font-size: 12pt;
  font-weight: 700;
  line-height: 1.5em;
}
</style>
